import { useCallback, useRef } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { uploadImportSpreadsheetToS3 } from 'src/services/media/S3FileHandler'

const S3_IMPORT_PREFIX = 'item-pool-imports'

// Uploads a spreadsheet once per attached file and resolves to its S3 path, so validating the import
// and creating it read the same upload. A failed upload is retried by the next call.
export const useImportSpreadsheetUpload = (): ((file: File) => Promise<string>) => {
    const uploaded = useRef<{ file: File; path: Promise<string> } | undefined>(undefined)

    return useCallback((file: File): Promise<string> => {
        if (uploaded.current?.file !== file) {
            const spreadsheetS3Path = `${S3_IMPORT_PREFIX}/${uuidv4()}-${file.name}`
            uploaded.current = {
                file,
                path: uploadImportSpreadsheetToS3(file, spreadsheetS3Path).then(
                    () => spreadsheetS3Path,
                    (e) => {
                        uploaded.current = undefined
                        throw e
                    }
                ),
            }
        }
        return uploaded.current.path
    }, [])
}
